// Synchronous platform detection via the Capacitor bridge object
// injected into the WebView at startup. Safe to call at module level.

export function isNativePlatform(): boolean {
  try {
    // window.Capacitor is injected by the native bridge before any JS runs
    const cap = (window as unknown as { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor
    return typeof cap?.isNativePlatform === 'function' && cap.isNativePlatform()
  } catch {
    return false
  }
}
